import React, { useState, useRef, useEffect } from "react";

// Full country list with dial codes
export const COUNTRIES = [
  { code:"PK", name:"Pakistan",          dial:"+92",  flag:"🇵🇰" },
  { code:"AE", name:"UAE",               dial:"+971", flag:"🇦🇪" },
  { code:"SA", name:"Saudi Arabia",      dial:"+966", flag:"🇸🇦" },
  { code:"IN", name:"India",             dial:"+91",  flag:"🇮🇳" },
  { code:"US", name:"United States",     dial:"+1",   flag:"🇺🇸" },
  { code:"GB", name:"United Kingdom",    dial:"+44",  flag:"🇬🇧" },
  { code:"CA", name:"Canada",            dial:"+1",   flag:"🇨🇦" },
  { code:"AU", name:"Australia",         dial:"+61",  flag:"🇦🇺" },
  { code:"DE", name:"Germany",           dial:"+49",  flag:"🇩🇪" },
  { code:"FR", name:"France",            dial:"+33",  flag:"🇫🇷" },
  { code:"IT", name:"Italy",             dial:"+39",  flag:"🇮🇹" },
  { code:"ES", name:"Spain",             dial:"+34",  flag:"🇪🇸" },
  { code:"NL", name:"Netherlands",       dial:"+31",  flag:"🇳🇱" },
  { code:"BE", name:"Belgium",           dial:"+32",  flag:"🇧🇪" },
  { code:"SE", name:"Sweden",            dial:"+46",  flag:"🇸🇪" },
  { code:"NO", name:"Norway",            dial:"+47",  flag:"🇳🇴" },
  { code:"DK", name:"Denmark",           dial:"+45",  flag:"🇩🇰" },
  { code:"CH", name:"Switzerland",       dial:"+41",  flag:"🇨🇭" },
  { code:"AT", name:"Austria",           dial:"+43",  flag:"🇦🇹" },
  { code:"PL", name:"Poland",            dial:"+48",  flag:"🇵🇱" },
  { code:"RU", name:"Russia",            dial:"+7",   flag:"🇷🇺" },
  { code:"TR", name:"Turkey",            dial:"+90",  flag:"🇹🇷" },
  { code:"EG", name:"Egypt",             dial:"+20",  flag:"🇪🇬" },
  { code:"NG", name:"Nigeria",           dial:"+234", flag:"🇳🇬" },
  { code:"ZA", name:"South Africa",      dial:"+27",  flag:"🇿🇦" },
  { code:"KE", name:"Kenya",             dial:"+254", flag:"🇰🇪" },
  { code:"GH", name:"Ghana",             dial:"+233", flag:"🇬🇭" },
  { code:"ET", name:"Ethiopia",          dial:"+251", flag:"🇪🇹" },
  { code:"TZ", name:"Tanzania",          dial:"+255", flag:"🇹🇿" },
  { code:"BD", name:"Bangladesh",        dial:"+880", flag:"🇧🇩" },
  { code:"LK", name:"Sri Lanka",         dial:"+94",  flag:"🇱🇰" },
  { code:"NP", name:"Nepal",             dial:"+977", flag:"🇳🇵" },
  { code:"MM", name:"Myanmar",           dial:"+95",  flag:"🇲🇲" },
  { code:"TH", name:"Thailand",          dial:"+66",  flag:"🇹🇭" },
  { code:"VN", name:"Vietnam",           dial:"+84",  flag:"🇻🇳" },
  { code:"ID", name:"Indonesia",         dial:"+62",  flag:"🇮🇩" },
  { code:"MY", name:"Malaysia",          dial:"+60",  flag:"🇲🇾" },
  { code:"PH", name:"Philippines",       dial:"+63",  flag:"🇵🇭" },
  { code:"SG", name:"Singapore",         dial:"+65",  flag:"🇸🇬" },
  { code:"HK", name:"Hong Kong",         dial:"+852", flag:"🇭🇰" },
  { code:"CN", name:"China",             dial:"+86",  flag:"🇨🇳" },
  { code:"JP", name:"Japan",             dial:"+81",  flag:"🇯🇵" },
  { code:"KR", name:"South Korea",       dial:"+82",  flag:"🇰🇷" },
  { code:"OM", name:"Oman",              dial:"+968", flag:"🇴🇲" },
  { code:"KW", name:"Kuwait",            dial:"+965", flag:"🇰🇼" },
  { code:"QA", name:"Qatar",             dial:"+974", flag:"🇶🇦" },
  { code:"BH", name:"Bahrain",           dial:"+973", flag:"🇧🇭" },
  { code:"JO", name:"Jordan",            dial:"+962", flag:"🇯🇴" },
  { code:"LB", name:"Lebanon",           dial:"+961", flag:"🇱🇧" },
  { code:"IQ", name:"Iraq",              dial:"+964", flag:"🇮🇶" },
  { code:"IR", name:"Iran",              dial:"+98",  flag:"🇮🇷" },
  { code:"AF", name:"Afghanistan",       dial:"+93",  flag:"🇦🇫" },
  { code:"MX", name:"Mexico",            dial:"+52",  flag:"🇲🇽" },
  { code:"BR", name:"Brazil",            dial:"+55",  flag:"🇧🇷" },
  { code:"AR", name:"Argentina",         dial:"+54",  flag:"🇦🇷" },
  { code:"CO", name:"Colombia",          dial:"+57",  flag:"🇨🇴" },
  { code:"CL", name:"Chile",             dial:"+56",  flag:"🇨🇱" },
  { code:"PE", name:"Peru",              dial:"+51",  flag:"🇵🇪" },
  { code:"NZ", name:"New Zealand",       dial:"+64",  flag:"🇳🇿" },
  { code:"PT", name:"Portugal",          dial:"+351", flag:"🇵🇹" },
  { code:"GR", name:"Greece",            dial:"+30",  flag:"🇬🇷" },
  { code:"CZ", name:"Czech Republic",    dial:"+420", flag:"🇨🇿" },
  { code:"HU", name:"Hungary",           dial:"+36",  flag:"🇭🇺" },
  { code:"RO", name:"Romania",           dial:"+40",  flag:"🇷🇴" },
  { code:"UA", name:"Ukraine",           dial:"+380", flag:"🇺🇦" },
  { code:"IL", name:"Israel",            dial:"+972", flag:"🇮🇱" },
  { code:"MA", name:"Morocco",           dial:"+212", flag:"🇲🇦" },
  { code:"TN", name:"Tunisia",           dial:"+216", flag:"🇹🇳" },
  { code:"DZ", name:"Algeria",           dial:"+213", flag:"🇩🇿" },
];

export default function PhoneInput({ value, onChange, name = "phone" }) {
  // Default to PK
  const [selected, setSelected] = useState(COUNTRIES[0]);
  const [open,     setOpen]     = useState(false);
  const [query,    setQuery]    = useState("");
  const ref = useRef(null);

  const filtered = query.trim()
    ? COUNTRIES.filter(c =>
        c.name.toLowerCase().includes(query.toLowerCase()) ||
        c.dial.includes(query) ||
        c.code.toLowerCase().includes(query.toLowerCase())
      )
    : COUNTRIES;

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const select = (country) => {
    setSelected(country);
    setOpen(false);
    setQuery("");
    // Rebuild full value with new dial code
    const local = value.replace(/^\+\d+\s*/, "");
    onChange({ target: { name, value: `${country.dial} ${local}` } });
  };

  const handleLocal = (e) => {
    onChange({ target: { name, value: `${selected.dial} ${e.target.value}` } });
  };

  const localNumber = value ? value.replace(/^\+\d+\s*/, "") : "";

  return (
    <>
      <style>{`
        .phi-wrap{position:relative;display:flex;align-items:stretch;border:1.5px solid #ede8e2;background:#fff;border-radius:3px;overflow:visible;transition:border-color .18s}
        .phi-wrap:focus-within{border-color:#c87090;box-shadow:0 0 0 3px rgba(200,112,144,0.08)}
        .phi-trigger{display:flex;align-items:center;gap:5px;padding:0 10px;cursor:pointer;background:#f7f4f1;border-right:1px solid #ede8e2;border:none;font-family:'DM Sans',sans-serif;font-size:13px;color:#1a1410;min-width:86px;white-space:nowrap;flex-shrink:0;transition:background .15s}
        .phi-trigger:hover{background:#f0ebe5}
        .phi-flag{font-size:16px}
        .phi-dial{font-size:12px;font-weight:500;color:#5a524c}
        .phi-chevron{font-size:9px;color:#a09890;margin-left:2px}
        .phi-input{border:none;background:transparent;font-size:13px;font-family:'DM Sans',sans-serif;color:#1a1410;outline:none;padding:10px 12px;width:100%;min-width:0}
        .phi-input::placeholder{color:#c0b8b0}

        .phi-dropdown{position:absolute;top:calc(100% + 4px);left:0;min-width:240px;background:#fff;border:1.5px solid #ede8e2;border-radius:4px;box-shadow:0 8px 28px rgba(0,0,0,0.12);z-index:9999;overflow:hidden}
        .phi-search{display:flex;align-items:center;border-bottom:1px solid #f0ebe5;padding:0 12px;gap:8px}
        .phi-search input{border:none;outline:none;font-size:12px;font-family:'DM Sans',sans-serif;color:#1a1410;padding:10px 0;width:100%;background:transparent}
        .phi-search input::placeholder{color:#c0b8b0}
        .phi-list{max-height:220px;overflow-y:auto}
        .phi-option{display:flex;align-items:center;gap:8px;padding:8px 12px;cursor:pointer;transition:background .12s;font-size:12.5px;color:#1a1410}
        .phi-option:hover{background:#fff5f8}
        .phi-option.active{background:#fdf0f4;color:#c87090}
        .phi-opt-flag{font-size:15px;flex-shrink:0}
        .phi-opt-name{flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
        .phi-opt-dial{font-size:11px;color:#a09890;flex-shrink:0}
        .phi-empty{padding:12px;font-size:12px;color:#a09890;text-align:center}
      `}</style>

      <div className="phi-wrap" ref={ref}>
        <button type="button" className="phi-trigger" onClick={() => setOpen(o => !o)}>
          <span className="phi-flag">{selected.flag}</span>
          <span className="phi-dial">{selected.dial}</span>
          <span className="phi-chevron">{open ? "▲" : "▼"}</span>
        </button>

        <input
          className="phi-input"
          type="tel"
          placeholder="Phone number"
          value={localNumber}
          onChange={handleLocal}
        />

        {open && (
          <div className="phi-dropdown">
            <div className="phi-search">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input
                autoFocus
                placeholder="Search country..."
                value={query}
                onChange={e => setQuery(e.target.value)}
              />
            </div>
            <div className="phi-list">
              {filtered.length === 0
                ? <div className="phi-empty">No results</div>
                : filtered.map(c => (
                    <div
                      key={c.code}
                      className={`phi-option ${c.code === selected.code ? "active" : ""}`}
                      onClick={() => select(c)}
                    >
                      <span className="phi-opt-flag">{c.flag}</span>
                      <span className="phi-opt-name">{c.name}</span>
                      <span className="phi-opt-dial">{c.dial}</span>
                    </div>
                  ))
              }
            </div>
          </div>
        )}
      </div>
    </>
  );
}
